<template>
	<div class="alert" v-prevent-overscroll>
		<div class="alert-area">
			<div class="error-wrapper">
				<img class="error-img" :src="url" @click.stop="closeReceiveCardError" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "receiveCardError",
	props: {
		info: { // 收到卡片错误
			type: Object,
			required: true,
			default: () => {
				return {}
			}
		},
	},
	data() {
		return {
			url: ''
		}
	},
	mounted() {

		this.init()

	},
	methods: {

		init() { // init 函数
			const { errorType, receiveConfig } = this.info
			this.url = receiveConfig.error[errorType] && receiveConfig.error[errorType].url
		},

		closeReceiveCardError() { // 关闭领取卡片错误弹窗
			this.$emit('emitEvent', {
				type: 'closeReceiveCardError',
				data: null,
				options: null
			})
		},

	}
}
</script>

<style scoped lang="scss">
.alert {
	position: fixed;
	width: 100%;
	height: 100vh;
	top: 0;
	left: 0;
	z-index: 100;
	background: rgba(0, 0, 0, 0.8);
}

.alert .alert-area {
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}

.error-wrapper {
	position: relative;
}

.error-img {
	width: 618px;
}
</style>